import { useEffect, useState } from "react";
import { snippetApi } from "../services/api";

/**
 * Fetch the allowed code-snippet languages from the backend (the single
 * source of truth — `snippets.models.LANGUAGE_ALLOWLIST`). Returns
 * `{ languages, loading }`.
 *
 * On error it falls back to an empty list rather than surfacing — the
 * language `<select>` simply has no options, and a submit is still validated
 * server-side by the allowlist, so we never accept an invalid value.
 */
const useSnippetLanguages = () => {
  const [languages, setLanguages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    snippetApi
      .languages()
      .then((response) => {
        if (active) setLanguages(response.data.languages || []);
      })
      .catch((err) => {
        // Fall back to an empty picker (submit is still server-validated), but
        // leave a breadcrumb — otherwise a 5xx just looks like "no languages".
        console.warn("Failed to load snippet languages:", err);
        if (active) setLanguages([]);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return { languages, loading };
};

export default useSnippetLanguages;
